import { t } from '@lingui/core/macro';
import {
    addDays,
    endOfMonth,
    endOfQuarter,
    endOfWeek,
    endOfYear,
    startOfMonth,
    startOfQuarter,
    startOfWeek,
    startOfYear,
} from 'date-fns';

import { toIsoDay } from './format';

export interface QuickPickSingle {
    id: string;
    label: string;
    value: string;
}

export interface QuickPickRange {
    id: string;
    label: string;
    from: string;
    to: string;
}

/** Takes the moment the popover opened, so the values are deterministic in tests. */
export function defaultQuickPicksSingle(referenceDate: Date): QuickPickSingle[] {
    const today = stripTime(referenceDate);
    return [
        single('today', t`Today`, today),
        single('tomorrow', t`Tomorrow`, addDays(today, 1)),
        single('next-week', t`Next week`, startOfWeek(addDays(today, 7), { weekStartsOn: 1 })),
    ];
}

/** The range picker's `presets: 'default'`; pass an array to override. */
export function defaultQuickPicksRange(referenceDate: Date): QuickPickRange[] {
    const today = stripTime(referenceDate);
    return [
        range(
            'this-week',
            t`This week`,
            startOfWeek(today, { weekStartsOn: 1 }),
            endOfWeek(today, { weekStartsOn: 1 }),
        ),
        range('this-month', t`This month`, startOfMonth(today), endOfMonth(today)),
        range('this-quarter', t`This quarter`, startOfQuarter(today), endOfQuarter(today)),
        range('year-to-date', t`Year to date`, startOfYear(today), today),
        range('this-year', t`This year`, startOfYear(today), endOfYear(today)),
    ];
}

function single(id: string, label: string, date: Date): QuickPickSingle {
    return { id, label, value: toIsoDay(date) };
}

function range(id: string, label: string, from: Date, to: Date): QuickPickRange {
    return { id, label, from: toIsoDay(from), to: toIsoDay(to) };
}

function stripTime(d: Date): Date {
    const out = new Date(d);
    out.setHours(0, 0, 0, 0);
    return out;
}
